"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconKmPerDay75 = function IconKmPerDay75(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.677 7.601A17 17 0 0 0 24 6.95v-2c1.786 0 3.54.247 5.227.728zm7.935 4.95a17 17 0 0 0-3.621-3.032l1.06-1.696a19 19 0 0 1 4.045 3.387zm2.653 3.908a16.9 16.9 0 0 1 1.47 4.486h.005c.165.929.252 1.872.26 2.82l-.004.295A17 17 0 1 1 15.883 8.761l.657 1.85 3.62-4.26-5.49-1 .536 1.505c-8.049 4.198-12.037 13.554-9.4 22.318 2.715 9.022 11.631 14.691 20.953 13.323 9.243-1.356 16.116-9.226 16.24-18.544H43v-.237a19 19 0 0 0-.722-4.993l-.006.002a19 19 0 0 0-1.212-3.148zm-15.545.471-4 8.51h-2l4-8.39h-4.53V15.3h6.52zm3.74 8.74c2.34 0 3.77-1.37 3.77-3.61A3.06 3.06 0 0 0 28 18.75a2.82 2.82 0 0 0-1.83.59l.24-2.34h3.9v-1.7H25l-.5 5.7H26a1.81 1.81 0 0 1 1.6-.8 1.64 1.64 0 0 1 1.71 1.8 1.74 1.74 0 0 1-1.85 2 2.62 2.62 0 0 1-2.25-1.26L23.93 24a4.09 4.09 0 0 0 3.53 1.67M21 33.52l-1.29-1.85v1.85H18V27.1h1.7v3.75l1.08-1.57h2l-1.58 1.93 1.92 2.31zm3.94-4.24H23.3v4.23h1.69v-2.09c0-.57.27-.84.68-.84s.56.31.56.78v2.15h1.57v-2.09c0-.57.27-.84.68-.84s.56.31.56.78v2.2h1.7v-2.72a1.44 1.44 0 0 0-1.53-1.65 1.53 1.53 0 0 0-1.49.91 1.39 1.39 0 0 0-1.4-.91 1.47 1.47 0 0 0-1.38.81z",
    clipRule: "evenodd"
  })));
};

export { IconKmPerDay75, IconKmPerDay75 as default };
